import * as CONST from 'common/const';
import createReducer from './createReducer';

const initialState = {
  downloading: false,
  downloadUrl: '',
  error: ''
}

export default createReducer(initialState, {
  [CONST.DOWNLOAD_SOURCE_REQUEST]: state => ({
    ...state,
    downloading: true,
    error: '',
  }),

  [CONST.DOWNLOAD_SOURCE_SUCCESS]: (state, action) => ({
    ...state,
    downloading: false,
    error: '',
    downloadUrl: action.downloadUrl,
  }),

  [CONST.DOWNLOAD_SOURCE_FAILURE]: (state, action) => ({
    ...state,
    downloading: false,
    downloadUrl: '',
    error: action.payload,
  }),
});

